import React from "react";
import { Wrapper, Logos } from "./styled";
import LogosGroup from "../../../../../images/logos/logos_group.svg";

const Header = () => {
  return (
    <Wrapper>
      <Logos src={LogosGroup} alt="logosGroup" />
    </Wrapper>
  );
};

export default Header;
